import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeProvider';
import { queryClient } from './platform/queryClient';
import { installMockApi } from './platform/mockApi';
import { initObservability, Sentry } from './platform/observability';
import { AppErrorFallback } from './components/AppErrorFallback';
import { router } from './routes';

// Initialize error/perf monitoring first so anything below is captured.
initObservability();

// When no real API base URL is configured, intercept fetch and serve the
// CRUD/submit endpoints from localStorage so the apiClient code path is
// exercised end-to-end without a backend.
if (!import.meta.env.VITE_API_BASE_URL) {
  installMockApi();
}

if (import.meta.env.DEV) {
  void import('@axe-core/react').then(({ default: axe }) => {
    void import('react').then((React) => {
      void import('react-dom').then((ReactDOM) => {
        axe(React, ReactDOM, 1000);
      });
    });
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={AppErrorFallback}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
